
export const perceptuallyUniformSequentialColormaps = [
    {value: 'viridis', label: 'Viridis'},
    {value: 'plasma', label: 'Plasma'},
    {value: 'inferno', label: 'Inferno'},
    {value: 'magma', label: 'Magma'},
    {value: 'cividis', label: 'Cividis'}
]

export const divergingColormaps = [
    {value: 'PiYG', label: 'Pink-YellowGreen'},
    {value: 'PRGn', label: 'Purple-Green'},
    {value: 'BrBG', label: 'Brown-BlueGreen'},
    {value: 'PuOr', label: 'Purple-Orange'},
    {value: 'RdGy', label: 'Red-Gray'},
    {value: 'RdBu', label: 'Red-Blue'},
    {value: 'RdYlBu', label: 'Red-Yellow-Blue'},
    {value: 'RdYlGn', label: 'Red-Yellow-Green'},
    {value: 'Spectral', label: 'Spectral'},
    {value: 'coolwarm', label: 'Cool-Warm'},
    {value: 'bwr', label: 'Blue-White-Red'},
    {value: 'seismic', label: 'Seismic'},
]

export const sequential1Colormaps = [
    {value: 'Greys', label: 'Grayscale'},
    {value: 'Purples', label: 'Purple'},
    {value: 'Blues', label: 'Blue'},
    {value: 'Greens', label: 'Green'},
    {value: 'Oranges', label: 'Orange'},
    {value: 'Reds', label: 'Red'},
    {value: 'YlOrBr', label: 'Yellow-Orange-Brown'},
    {value: 'YlOrRd', label: 'Yellow-Orange-Red'},
    {value: 'OrRd', label: 'Orange-Red'},
    {value: 'PuRd', label: 'Purple-Red'},
    {value: 'RdPu', label: 'Red-Purple'},
    {value: 'BuPu', label: 'Blue-Purple'},
    {value: 'GnBu', label: 'Green-Blue'},
    {value: 'PuBu', label: 'Purple-Blue'},
    {value: 'YlGnBu', label: 'Yellow-Green-Blue'},
    {value: 'PuBuGn', label: 'Purple-Blue-Green'},
    {value: 'BuGn', label: 'Blue-Green'},
    {value: 'YlGn', label: 'Yellow-Green'},
]

export const sequential2Colormaps = [
    {value: 'binary', label: 'Binary'},
    {value: 'gist_gray', label: 'GIST Gray'},
    {value: 'gray', label: 'Gray'},
    {value: 'bone', label: 'Bone'},
    {value: 'pink', label: 'Pink'},
    {value: 'spring', label: 'Spring'},
    {value: 'summer', label: 'Summer'},
    {value: 'autumn', label: 'Autumn'},
    {value: 'winter', label: 'Winter'},
    {value: 'cool', label: 'Cool'},
    {value: 'Wistia', label: 'Wistia'},
    {value: 'hot', label: 'Hot'},
    {value: 'afmhot', label: 'AFM Hot'},
    {value: 'gist_heat', label: 'GIST Heat'},
    {value: 'copper', label: 'Copper'},
]

export const cyclicColormaps = [
    {value: 'twilight', label: 'Twilight'},
    {value: 'twilight_shifted', label: 'Twilight (Shifted)'},
    {value: 'hsv', label: 'HSV'}
]

export const instrumentColormaps = [
    {value: 'goes-rsuvi94', label: 'GOES SUVI (94)'},
    {value: 'goes-rsuvi131', label: 'GOES SUVI (131)'},
    {value: 'goes-rsuvi171', label: 'GOES SUVI (171)'},
    {value: 'goes-rsuvi195', label: 'GOES SUVI (195)'},
    {value: 'goes-rsuvi284', label: 'GOES SUVI (284)'},
    {value: 'goes-rsuvi304', label: 'GOES SUVI (304)'},
    {value: 'sdoaia94', label: 'SDO AIA (94)'},
    {value: 'sdoaia131', label: 'SDO AIA (131)'},
    {value: 'sdoaia171', label: 'SDO AIA (171)'},
    {value: 'sdoaia193', label: 'SDO AIA (193)'},
    {value: 'sdoaia211', label: 'SDO AIA (211)'},
    {value: 'sdoaia304', label: 'SDO AIA (304)'},
    {value: 'sdoaia335', label: 'SDO AIA (335)'},
    {value: 'sdoaia1600', label: 'SDO AIA (1600)'},
    {value: 'sdoaia1700', label: 'SDO AIA (1700)'},
    {value: 'sdoaia4500', label: 'SDO AIA (4500)'},
    {value: 'sohoeit171', label: 'SOHO EIT (171)'},
    {value: 'sohoeit195', label: 'SOHO EIT (195)'},
    {value: 'sohoeit284', label: 'SOHO EIT (284)'},
    {value: 'sohoeit304', label: 'SOHO EIT (304)'},
    {value: 'soholasco2', label: 'SOHO LASCO-2'},
    {value: 'soholasco3', label: 'SOHO LASCO-3'},
    {value: 'sswidlsoholasco2', label: 'SSW IDL SOHO LASCO-2'},
    {value: 'sswidlsoholasco3', label: 'SSW IDL SOHO LASCO-3'},
    {value: 'stereocor1', label: 'STEREO COR-1'},
    {value: 'stereocor2', label: 'STEREO COR-2'},
    {value: 'stereohi1', label: 'STEREO HI-1'},
    {value: 'stereohi2', label: 'STEREO HI-2'},
    {value: 'yohkohsxtal', label: 'Yohkoh SXT (AL)'},
    {value: 'yohkohsxtwh', label: 'Yohkoh SXT (WH)'},
    {value: 'hinodexrt', label: 'Hinode XRT'},
    {value: 'hinodesotintensity', label: 'Hinode SOT'},
    {value: 'trace171', label: 'TRACE (171)'},
    {value: 'trace195', label: 'TRACE (195)'},
    {value: 'trace284', label: 'TRACE (284)'},
    {value: 'trace1216', label: 'TRACE (1216)'},
    {value: 'trace1550', label: 'TRACE (1550)'},
    {value: 'trace1600', label: 'TRACE (1600)'},
    {value: 'trace1700', label: 'TRACE (1700)'},
    {value: 'traceWL', label: 'TRACE (WL)'},
    {value: 'hmimag', label: 'HMI (mag)'},
    {value: 'irissji1330', label: 'IRIS SJI (1330)'},
    {value: 'irissji1400', label: 'IRIS SJI (1400)'},
    {value: 'irissji1600', label: 'IRIS SJI (1600)'},
    {value: 'irissji2796', label: 'IRIS SJI (2796)'},
    {value: 'irissji2832', label: 'IRIS SJI (2832)'},
    {value: 'irissji5000', label: 'IRIS SJI (5000)'},
    {value: 'irissjiFUV', label: 'IRIS SJI (FUV)'},
    {value: 'irissjiNUV', label: 'IRIS SJI (NUV)'},
    {value: 'irissjiSJI_NUV', label: 'IRIS SJI (SJI-NUV)'},
    {value: 'kcor', label: 'KCOR'},
    {value: 'rhessi', label: 'RHESSI'},
    {value: 'std_gamma_2', label: 'STD Gamma 2'},
    {value: 'euvi171', label: 'EUVI (171)'},
    {value: 'euvi195', label: 'EUVI (195)'},
    {value: 'euvi284', label: 'EUVI (284)'},
    {value: 'euvi304', label: 'EUVI (304'},
    {value: 'solar orbiterfsi174', label: 'SOLO FSI (174)'},
    {value: 'solar orbiterfsi304', label: 'SOLO FSI (304'},
    {value: 'solar orbiterhri_euv174', label: 'SOLO HRI-EUV (174)'},
    {value: 'solar orbiterhri_lya1216', label: 'SOLO HRI-LYA (1216)'}
]

export const psiColormaps = [
    {value: 'psi_seismic', label: 'PSI Seismic'},
    {value: 'psi_blue_red', label: 'PSI Blue-White-Red'},
    {value: 'psi_aqua_crimson_dark', label: 'PSI Aqua Crimson (Dark)'},
    {value: 'psi_aqua_crimson', label: 'PSI Aqua Crimson'},
    {value: 'psi_blue_white', label: 'PSI Blue-White'},
    {value: 'psi_grayscale', label: ' PSI Grayscale'},
    {value: 'psi_hotmetal', label: 'PSI Hotmetal'},
    {value: 'psi_rainbow', label: 'PSI Rainbow'},
    {value: 'psi_blue_green_red_yellow', label: 'PSI Blue-Green-Red-Yellow'},
    {value: 'psi_rainbow_banded', label: 'PSI Rainbow Banded'},
    {value: 'psi_volcano', label: 'PSI Volcano'},
    {value: 'psi_saturn', label: 'PSI Saturn'},
    {value: 'psi_aia_0094', label: 'PSI AIA (94)'},
    {value: 'psi_aia_0131', label: 'PSI AIA (131)'},
    {value: 'psi_aia_0171', label: 'PSI AIA (171)'},
    {value: 'psi_aia_0193', label: 'PSI AIA (193)'},
    {value: 'psi_aia_0211', label: 'PSI AIA (211)'},
    {value: 'psi_aia_0304', label: 'PSI AIA (304)'},
    {value: 'psi_aia_0335', label: 'PSI AIA (335)'},
    {value: 'psi_aia_1600', label: 'PSI AIA (1600)'},
    {value: 'psi_aia_1700', label: 'PSI AIA (1700)'},
    {value: 'psi_aia_4500', label: 'PSI AIA (4500)'},
    {value: 'psi_eit_blue_v2', label: 'PSI EIT (171)'},
    {value: 'psi_eit_green_v2', label: 'PSI EIT (195)'},
    {value: 'psi_eit_yellow_v2', label: 'PSI EIT (284)'},
    {value: 'psi_eit_red_v2', label: 'PSI EIT (304)'},
    {value: 'psi_blue_gray_red', label: 'PSI Blue-Gray-Red'}
]

export const miscellaneousColormaps = [
    {value: 'ocean', label: 'Ocean'},
    {value: 'gist_earth', label: 'GIST Earth'},
    {value: 'terrain', label: 'Terrain'},
    {value: 'gist_stern', label: 'GIST Stern'},
    {value: 'gnuplot', label: 'GNU Plot'},
    {value: 'gnuplot2', label: 'GNU Plot (2)'},
    {value: 'CMRmap', label: 'CMR Map'},
    {value: 'cubehelix', label: 'Cube Helix'},
    {value: 'brg', label: 'Blue-Red-Green'},
    {value: 'gist_rainbow', label: 'GIST Rainbow'},
    {value: 'rainbow', label: 'Rainbow'},
    {value: 'jet', label: 'Jet'},
    {value: 'turbo', label: 'Turbo'},
    {value: 'nipy_spectral', label: 'NIPY Spectral'},
    {value: 'gist_ncar', label: 'NIPY NCAR'},
]
